import { createAsyncThunk } from "@reduxjs/toolkit";
import { getSettings } from "../../../api/api";

export const getAppData = createAsyncThunk(
	"general/getAppData",
	async ({ layout }: { layout?: string }) => {
		try {
			const response = await getSettings(layout);

			return response;
		} catch (error) {
			return { layout, error };
		}
	},
);
